import ProjectList from '../../components/ProjectList';
import { detailsBackground } from '../../config/colors';
import { ScreenWrapper, ScrollerWrapper } from '../../styles/common';

const ProjectListScreen = () => {
  return (
    <ScreenWrapper>
      <ScrollerWrapper background={detailsBackground}>
        <ProjectList />
      </ScrollerWrapper>
    </ScreenWrapper>
  );
};

export default ProjectListScreen;
